import * as Actions from "store/actions/app/menu_control.actions"
import { addOrUpdateObjectInArray } from "utils/add-or-update-object-in-array"

const initialState = {
  loading_menus: false,
  menus: [],

  saving_menu: false,
  saved_menu: false,

  deleting_menu: false,
  deleted_menu: false,
}

const menuControlReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_MENUS: {
      return {
        ...state,
        loading_menus: action.payload.loading ?? false,
        menus: action.payload.data ?? state.menus
      }
    }
    case Actions.SAVE_MENU: {
      return {
        ...state,
        saving_menu: action.payload.saving ?? false,
        saved_menu: action.payload.saved ?? false,
        menus: action.payload.data
          ? addOrUpdateObjectInArray(state.menus, action.payload.data, 'menu_id', true)
          : state.menus
      }
    }
    case Actions.DELETE_MENU: {
      return {
        ...state,
        deleting_menu: action.payload.deleting ?? false,
        deleted_menu: action.payload.deleted ?? false,
        menus: state.menus.filter(menu => menu.menu_id !== action.payload.deleted_id)
      }
    }
    default: {
      return state
    }
  }
}

export default menuControlReducer